import { render } from "./ConversationItem.vue?vue&type=template&id=694a3ba8&scoped=true"
import script from "./ConversationItem.vue?vue&type=script&lang=js"
export * from "./ConversationItem.vue?vue&type=script&lang=js"

import "./ConversationItem.vue?vue&type=style&index=0&id=694a3ba8&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694a3ba8"]])

export default __exports__